module.exports = __webpack_public_path__ + "img/zuo.e3a1cf47.png";